import { Route } from '@/app/router'

const FailedOrders = () => import('./index.vue')

export default new Route('/orders/failed', FailedOrders)
	.as('Dashboard:FailedOrders')
	.permissions(['VIEW_ORDER'])
